const LIGHT_COLOR_PALETTES = {
  default: [
    'error', 'success', 'primary', 'purple', 'pink',
    'cyan', 'indigo', 'blue', 'teal', 'amber',
    'blue-grey', 'light-green', 'orange', 'brown', 'light-blue', 'deep-purple'
  ],
  roomAllocation: [
    'error', 'success', 'primary', 'purple', 'pink',
    'cyan', 'indigo', 'blue', 'teal', 'amber', 'blue-grey', 'amber'
  ],
  batchJoin: [
    'error', 'success', 'primary', 'purple', 'pink',
    'cyan', 'indigo', 'blue', 'teal', 'amber', 'blue-grey'
  ],
  message: [
    'error', 'success', 'indigo', 'primary', 'purple',
    'pink', 'cyan', 'blue-grey', 'blue', 'teal', 'amber'
  ]
}

const DARK_COLOR_PALETTES = {
  default: [
    '#EF5350', '#66BB6A', '#42A5F5', '#AB47BC', '#EC407A',
    '#26C6DA', '#5C6BC0', '#29B6F6', '#26A69A', '#FFCA28',
    '#78909C', '#9CCC65', '#FFA726', '#8D6E63', '#4FC3F7', '#7E57C2'
  ],
  roomAllocation: [
    '#EF5350', '#66BB6A', '#42A5F5', '#AB47BC', '#EC407A',
    '#26C6DA', '#5C6BC0', '#29B6F6', '#26A69A', '#FFCA28',
    '#78909C', '#FFCA28'
  ],
  batchJoin: [
    '#EF5350', '#66BB6A', '#42A5F5', '#AB47BC', '#EC407A',
    '#26C6DA', '#5C6BC0', '#29B6F6', '#26A69A', '#FFCA28', '#78909C'
  ],
  message: [
    '#EF5350', '#66BB6A', '#5C6BC0', '#42A5F5', '#AB47BC',
    '#EC407A', '#26C6DA', '#78909C', '#29B6F6', '#26A69A', '#FFCA28'
  ]
}

export const getThemeColorPalette = (isDark, paletteName = 'default') => {
  const palettes = isDark ? DARK_COLOR_PALETTES : LIGHT_COLOR_PALETTES
  const palette = palettes[paletteName] || palettes.default
  return [...palette]
}
